import { ReactElement, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import DashboardLoader from '@/components/shared/DashboardLoader';
import { useAppDispatch, useAppSelector } from '@/store';
import { explicitLogoutSelector, loggedInSelector } from '@/store/auth/selectors';
import { initDashboard } from '@/store/dashboard';
import {
  initializedSelector,
  initializeFailedSelector,
  initializingDashboardSelector,
} from '@/store/dashboard/selectors';

const AuthRoute: React.FC<{ children?: ReactElement }> = ({ children }) => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const initialized = useAppSelector(initializedSelector);
  const initializeFailed = useAppSelector(initializeFailedSelector);
  const initializingDashboard = useAppSelector(initializingDashboardSelector);
  const loggedIn = useAppSelector(loggedInSelector);
  const explicitLogout = useAppSelector(explicitLogoutSelector);

  useEffect(() => {
    if (!initializingDashboard && !initialized && loggedIn) dispatch(initDashboard());
  }, [initializingDashboard, initialized, loggedIn, dispatch]);

  if (!loggedIn) {
    const fullPath = location.pathname + location.search + location.hash;
    const withRedirect = !explicitLogout && fullPath !== '/' && fullPath !== '';
    const loginUrl = withRedirect ? `/login?redirect_to=${encodeURIComponent(fullPath)}` : '/login';
    return <Navigate to={loginUrl} replace />;
  }

  if (initializingDashboard || (!initializingDashboard && initializeFailed) || !initialized) {
    return <DashboardLoader />;
  }

  return children ? children : <Outlet />;
};

export default AuthRoute;
